
var protocal = window.location.protocol;
var hostname = window.location.hostname;

var port = window.location.port;
var url = '';
var webProcal = 'ws';
if (protocal == 'https:') {
    webProcal = 'wss'
}
let webSocketBAse = webProcal;

//todo 测试使用，生产关掉8080
//if (port == 80 || port == 8080) {

if (port == 80) {
    url = protocal + '//' + hostname;
    webSocketBAse = webProcal + "://" + hostname
} else {
    url = protocal + '//' + hostname + ":" + port;
    webSocketBAse = webProcal + "://" + hostname+ ":" + port;
}




export const API_BASE_URL = url;
export const API_URL = {
    "langGetWords": API_BASE_URL + '/api/lang/getWords',
    "langChange": API_BASE_URL + '/api/lang/change',
    "jsError": API_BASE_URL + '/api/js/error',    

    "userLogin": API_BASE_URL + '/api/user/login',
    "userLogined": API_BASE_URL + '/api/user/logined',
    "userLogout": API_BASE_URL + '/api/user/logout',
    "userGetInfo": API_BASE_URL + '/api/user/getInfo',
    'userGet': API_BASE_URL + '/api/user/get',
    'userGetOne': API_BASE_URL + '/api/user/getOne',
    'userAdd': API_BASE_URL + '/api/user/add',
    'userUpdate': API_BASE_URL + '/api/user/update',
    'userDelete': API_BASE_URL + '/api/user/delete',
    'userRecover': API_BASE_URL + '/api/user/recover',
    'userModifyPassword': API_BASE_URL + '/api/user/modifyPassword',
    'userExport': API_BASE_URL + '/api/user/export',
    'userImport': API_BASE_URL + '/api/user/import',

    'roleGet': API_BASE_URL + '/api/role/get',
    'roleGetOne': API_BASE_URL + '/api/role/getOne',
    'roleAdd': API_BASE_URL + '/api/role/add',
    'roleUpdate': API_BASE_URL + '/api/role/update',
    'roleDelete': API_BASE_URL + '/api/role/delete',
    'roleRecover': API_BASE_URL + '/api/role/recover',
    'roleGetAll': API_BASE_URL + '/api/role/getAll',
    'roleUpdateAuth': API_BASE_URL + '/api/role/updateAuth',
    'roleExport': API_BASE_URL + '/api/role/export',
    'roleImport': API_BASE_URL + '/api/role/import',
    

    'machineGet': API_BASE_URL + '/api/machine/get',
    'machineGetOne': API_BASE_URL + '/api/machine/getOne',
    'machineAdd': API_BASE_URL + '/api/machine/add',
    'machineUpdate': API_BASE_URL + '/api/machine/update',
    'machineDelete': API_BASE_URL + '/api/machine/delete',
    'machineRealDelete': API_BASE_URL + '/api/machine/realDelete',
    'machineRecover': API_BASE_URL + '/api/machine/recover',
    'machineOnline': API_BASE_URL + '/api/machine/online',
    'machineOffline': API_BASE_URL + '/api/machine/offline',
    'machineExportData': API_BASE_URL + '/api/machine/exportData',
    'machineImportData': API_BASE_URL + '/api/machine/importData',
    'machineSettingInfo': API_BASE_URL + '/api/machine/settingInfo',
    'machineSettingSet': API_BASE_URL + '/api/machine/settingSet',
    'machineAllOnline': API_BASE_URL + '/api/machine/allOnline',
    'machineAllOffline': API_BASE_URL + '/api/machine/allOffline',
    'machineWarnReset': API_BASE_URL + '/api/machine/warnReset',  
    'machineGetBackupList': API_BASE_URL + '/api/machine/getBackupList',    
    'machineDownloadBackup': API_BASE_URL + '/api/machine/downloadBackup',
    'machineBackup': API_BASE_URL + '/api/machine/backup',
    'machineSoftwareUpgrade': API_BASE_URL + '/api/machine/softwareUpgrade',
    'machineSoftwareUpgradeRetry': API_BASE_URL + '/api/machine/softwareUpgradeRetry',
    'machineSoftwareUpgradeCancel': API_BASE_URL + '/api/machine/softwareUpgradeCancel',
    'machineBackupRetry': API_BASE_URL + '/api/machine/backupRetry',
    'machineBackupCancel': API_BASE_URL + '/api/machine/backupCancel',
    'machineKindList': API_BASE_URL + '/api/machine/kindList',
    'machineRevert': API_BASE_URL + '/api/machine/revert',
    'machineRevertRetry': API_BASE_URL + '/api/machine/revertRetry',    
    'machineClearBackup': API_BASE_URL + '/api/machine/clearBackup',
    'machineSpotRefresh': API_BASE_URL + '/api/machine/spotRefresh',
    'machineSpotRefreshRetry': API_BASE_URL + '/api/machine/spotRefreshRetry',
    'machineGetWarning': API_BASE_URL + '/api/machine/getWarning',
    'machineExportWarning': API_BASE_URL + '/api/machine/exportWarning',
    'machineGetInfo':API_BASE_URL + '/api/machine/getInfo',
    
    'productlineGet': API_BASE_URL + '/api/productline/get',
    'productlineGetAll': API_BASE_URL + '/api/productline/getAll',
    'productlineGetOne': API_BASE_URL + '/api/productline/getOne',
    'productlineAdd': API_BASE_URL + '/api/productline/add',
    'productlineUpdate': API_BASE_URL + '/api/productline/update',
    'productlineDelete': API_BASE_URL + '/api/productline/delete',
    'productlineRecover': API_BASE_URL + '/api/productline/recover',
    'productlineGetWithMachine': API_BASE_URL + '/api/productline/getWithMachine',

    'libraryGetAll': API_BASE_URL + '/api/library/getAll',
    'libraryGetOne': API_BASE_URL + '/api/library/getOne',
    'libraryAdd': API_BASE_URL + '/api/library/add',
    'libraryUpdate': API_BASE_URL + '/api/library/update',
    'libraryDelete': API_BASE_URL + '/api/library/delete',
    'libraryCopy': API_BASE_URL + '/api/library/copy',
    'libraryInit': API_BASE_URL + '/api/library/init',
    'libraryCompare': API_BASE_URL + '/api/library/compare',
    'libraryDownload': API_BASE_URL + '/api/library/download',
    'libraryDownloadInit': API_BASE_URL + '/api/library/downloadInit',
    'libraryDownloadOne': API_BASE_URL + '/api/library/downloadOne',
    'libraryDownloadBatch': API_BASE_URL + '/api/library/downloadBatch',
    'libraryCopyPost': API_BASE_URL + '/api/library/copyPost',
    'librarySystemCompare': API_BASE_URL + '/api/library/systemCompare',

    'historyGet': API_BASE_URL + '/api/history/get',
    'historyExportData': API_BASE_URL + '/api/history/exportData',

    'initInfo': API_BASE_URL + '/api/init/info',    
    'initClear': API_BASE_URL + '/api/init/clear',

    'webSocket': webSocketBAse + "/api/websocket",

    'programInit': API_BASE_URL + '/api/program/init',
    'programInfo': API_BASE_URL + '/api/program/info',
    'programDownload': API_BASE_URL + '/api/program/download',
    'programSync': API_BASE_URL + '/api/program/sync',
    'programExport': API_BASE_URL + '/api/program/export',
    'programImport': API_BASE_URL + '/api/program/import',

    'systemInfo': API_BASE_URL + '/api/system/info',
    'systemUirInfo': API_BASE_URL + '/api/system/uirInfo',
    'systemCalOneInfo': API_BASE_URL + '/api/system/calOneInfo',
    'systemCalTwoInfo': API_BASE_URL + '/api/system/calTwoInfo',
    'systemCalThreeInfo': API_BASE_URL + '/api/system/calThreeInfo',
    'systemCalFourInfo': API_BASE_URL + '/api/system/calFourInfo',
    'systemCalFiveInfo': API_BASE_URL + '/api/system/calFiveInfo',
    'systemCalOnePss': API_BASE_URL + '/api/system/calOnePss',   
    'systemCalOneCurrentadj': API_BASE_URL + '/api/system/calOneCurrentadj',
    'systemCalTwoCurrentadj': API_BASE_URL + '/api/system/calTwoCurrentadj',
    'systemCalThreeCurrentadj': API_BASE_URL + '/api/system/calThreeCurrentadj',
    'systemCalFourCurrentadj': API_BASE_URL + '/api/system/calFourCurrentadj',
    'systemCalFiveCurrentadj': API_BASE_URL + '/api/system/calFiveCurrentadj',
    'systemCalOneCurrent': API_BASE_URL + '/api/system/calOneCurrent',
    'systemUipHistory': API_BASE_URL + '/api/system/uipHistory',
    'systemUirHistory': API_BASE_URL + '/api/system/uirHistory',

    'systemUirDelete': API_BASE_URL + '/api/system/uirDelete',    
    'systemUirDownloadMachine': API_BASE_URL + '/api/system/uirDownloadMachine',
    'systemUirDownloadPc': API_BASE_URL + '/api/system/uirDownloadPc',
    'SystemParamDownload': API_BASE_URL + '/api/system/paramDownload',
    'systemWeldingInfo': API_BASE_URL + '/api/system/weldingInfo',
    'systemWeldingDownload': API_BASE_URL + '/api/system/weldingDownload',
    'systemUirSettingDownload': API_BASE_URL + '/api/system/uirSettingDownload',
    'systemUipSettingDownload': API_BASE_URL + '/api/system/uipSettingDownload',
    'systemSoftwareUpgrade': API_BASE_URL + '/api/system/softwareUpgrade',
    'systemSoftwareReset': API_BASE_URL + '/api/system/softwareReset',
    'systemBackupImport': API_BASE_URL + '/api/system/backupImport',
    'systemBackupExport': API_BASE_URL + '/api/system/backupExport',
    'systemUirStart': API_BASE_URL + '/api/system/uirStart',
    'systemUirEnd': API_BASE_URL + '/api/system/uirEnd',
    'systemVersion': API_BASE_URL + '/api/system/version',    

    'productionInit': API_BASE_URL + '/api/production/init',
    'productionInfo': API_BASE_URL + '/api/production/info',
    'productionElectrodeOneInfo': API_BASE_URL + '/api/production/electrodeOneInfo',
    'productionElectrodeTwoInfo': API_BASE_URL + '/api/production/electrodeTwoInfo',
    'productionElectrodeOneFix': API_BASE_URL + '/api/production/electrodeOneFix',
    'productionElectrodeTwoFix': API_BASE_URL + '/api/production/electrodeTwoFix',
    'ProductionManagerDownload': API_BASE_URL + '/api/production/managerDownload',
    'ProductionCountOneDownload': API_BASE_URL + '/api/production/countOneDownload',
    'ProductionCountTwoDownload': API_BASE_URL + '/api/production/countTwoDownload',
    'ProductionFixOneDownload': API_BASE_URL + '/api/production/fixOneDownload',
    'ProductionFixTwoDownload': API_BASE_URL + '/api/production/fixTwoDownload',

    'alarmGet': API_BASE_URL + '/api/alarm/get',
    'alarmDelete': API_BASE_URL + '/api/alarm/delete',
    'alarmExport': API_BASE_URL + '/api/alarm/export',

    'recordGet': API_BASE_URL + '/api/record/get',
    'recordDelete': API_BASE_URL + '/api/record/delete',
    'recordExport': API_BASE_URL + '/api/record/export',
    'recordDetail': API_BASE_URL + '/api/record/detail',
    'recordInit': API_BASE_URL + '/api/record/init',
    'recordLastCurve': API_BASE_URL + '/api/record/lastCurve',

    'recordTendances': API_BASE_URL + '/api/record/tendances', 
    
    'uirCurveGet':API_BASE_URL + '/api/uir_curve/curve', 

    'modificationGet': API_BASE_URL + '/api/modification/get',
    'modificationExport': API_BASE_URL + '/api/modification/export',
    'modificationProdspotGet': API_BASE_URL + '/api/modification/prodspotGet',
    'modificationProdspotExport': API_BASE_URL + '/api/modification/prodspotExport',

    'prodspotGet': API_BASE_URL + '/api/prodspot/get',
    'prodspotGetOne': API_BASE_URL + '/api/prodspot/getOne',
    'prodspotAdd': API_BASE_URL + '/api/prodspot/add',
    'prodspotUpdate': API_BASE_URL + '/api/prodspot/update',
    'prodspotRefresh': API_BASE_URL + '/api/prodspot/refresh',
    'prodspotImport': API_BASE_URL + '/api/prodspot/import',
    'prodspotValid': API_BASE_URL + '/api/prodspot/valid',
    'prodspotExport': API_BASE_URL + '/api/prodspot/export',
    'prodspotNew': API_BASE_URL + '/api/prodspot/new',
    'prodspotClear': API_BASE_URL + '/api/prodspot/clear',
    'prodspotDownload': API_BASE_URL + '/api/prodspot/download',
    'prodspotDelete': API_BASE_URL + '/api/prodspot/delete',

    'registerInit': API_BASE_URL + '/api/register/init',
    'registerPost': API_BASE_URL + '/api/register/post',
    'registerCreate': API_BASE_URL + '/api/register/create',
    

    'runningInit': API_BASE_URL + '/api/running/init',
    'runningOperate': API_BASE_URL + '/api/running/operate',

    'settingInit': API_BASE_URL + '/api/setting/init',
    'settingUpdate': API_BASE_URL + '/api/setting/update',
    'settingGet': API_BASE_URL + '/api/setting/get',

    'expulsionGet': API_BASE_URL + '/api/expulsion/get',
    'expulsionExport': API_BASE_URL + '/api/expulsion/export',
    'expulsionGetCarModelData': API_BASE_URL + '/api/expulsion/getCarModelData',

    'invokeExternalApp': API_BASE_URL + '/api/invoke/externalApp',
    'saveExternalApp': API_BASE_URL + '/api/invoke/saveExternalApp',   
    
    'fixInit': API_BASE_URL + '/api/fix/init',
    'fixQuery': API_BASE_URL + '/api/fix/query',
    'fixSaveRefCurve': API_BASE_URL + '/api/fix/saveRefCurve',

    'downloadList': API_BASE_URL + '/api/download/list',
    'downloadFile': API_BASE_URL + '/api/download/file',

    'fixAlarmGet': API_BASE_URL + '/api/fixalarm/get',

    'robotChat': API_BASE_URL + '/api/robot/chat',

}

export const PAGE_SIZE_ARY = [20, 50, 100, 500];